export const options = [
  { value: "fr", label: "Français" },
  { value: "en", label: "English" },   
  { value: "ar", label: "Arabic" }
];
